// extracted by mini-css-extract-plugin
export default {"cls1":"VeloListCurrencyAmount-Skeleton_cls1__bbNRa","cls2":"VeloListCurrencyAmount-Skeleton_cls2__6i1H9 VeloListCurrencyAmount-Skeleton_cls1__bbNRa"};